export default __webpack_public_path__ + "static/media/001-whale.bd352698.png";